<template>
  <div class="Detail">
    <div class="container">
      <!-- 内容层开始 -->
      <div class="box" v-if="detail">
        <!--<div class="box_title">-->
          <!--<van-image class="img" :src="detail.image" fit="contain" />-->
        <!--</div>-->
        <div class="box_content">
          <div class="title">
            <!--<div>{{ // detail.name }}</div>-->
            <!--<div>456</div>-->
            <div class="left">{{ detail.name }}</div>
            <div class="right">
              <van-image class="img" :src="require('@/assets/images/book/icon_17.png')"></van-image>
              <div class="text">{{ detail.booksNum }}本</div>
              <div class="box">
                <div class="box_left">
                  <ul class="list">
                    <li class="list_item"
                      v-for="(item, index) in operations"
                      :key="index"
                      @click="itemClick"
                    >
                      <!-- <van-image class="img" :src="item.src"></van-image>
                      <van-image class="img" :src="item.active"></van-image> -->
                      <i class="icon" :class="{'active': detail.isCollected}"></i>
                      <div class="text" v-if="detail.isCollected">{{ item.activeText }}</div>
                      <div class="text" v-else>{{ item.text }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="text" v-html="detail.content"></div>
        </div>
        <div class="box_bottom"></div>
      </div>
      <!-- 内容层结束 -->

      <!-- 书籍列表开始 -->
      <Empty v-if="bookDetail.totalCount === 0" />
      <van-list
        v-else
        v-model="bookDetail.loading"
        :finished="bookDetail.finished"
        finished-text="没有更多了"
        @load="getBookDetail"
      >
          <template v-slot:finished>
            <van-divider style="width:50%;margin:30px auto;">
              暂无更多
            </van-divider>
          </template>
          <div class="box2">
            <div class="box_item"
              @click="$router.push({name:'BookListDetail',query:{id:item.id}})"
              v-for="item in bookDetail.list"
              :key="item.id"
            >
              <van-image class="img" :src="item.image"></van-image>
              <div class="info">
                <div class="title">{{ item.name }}</div>
              </div>
            </div>
          </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Empty from '../../components/Empty.vue';
import { Dialog } from 'vant';
export default {
  components: { Empty },
  data () {
    return {
      id: '',
      active: 2, // 教学资源
      type: 0, // 购买课程
      detail: {}, // 详情信息

      // 收藏操作
      operations: [
        {
          src: require('@/assets/images/book/icon_star_01.png'),
          active: require('@/assets/images/book/icon_star_02.png'),
          text: '收藏',
          activeText: '已收藏'
        }
      ],

      bookDetail: {
        finished: false,
        loading: false,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 10
      }
    };
  },
  computed: {

  },
  watch: {

  },
  mounted () {
    const { $route: { query: { id } } } = this;
    this.id = id * 1 || '';
    this.getDetail();
  },
  methods: {

    /* 初始化列表数据 */
    async init () {
      this.bookDetail = {
        finished: false,
        loading: false,
        list: [],
        totalCount: '',
        pageNo: 1,
        pageSize: 10
      };
    },

    /* 获取详情页信息 */
    getDetail () {
      const { $http, id, $utils, $router } = this;
      if (id) {
        $http.get('bookshelf/detail', {
          params: {
            id
          }
        }).then((res) => {
          console.log('结果', res);
          this.detail = res.data || {};
          if (this.detail.code == -1){
            // 这里执行跳转弹窗提示
            Dialog.confirm({
              title: '提示',
              message: '该书架需要登录才能查看，是否登录',
              confirmButtonText: '去登录',
            }).then(() => {
              // 点击确认按钮事件处理
              console.log("点击了确认按钮");
              $router.push({
                name: 'Login',
                query: { redirect: '/bookshelfDetail?id='+id } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
              });
            }).catch(() => {
              // 点击取消按钮事件处理
              history.go(-1);
            });
          }
          this.$wxShare({
            // url: window.href, // 网址，默认使用 window.location.href
            title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
            desc: this.detail.content || '广东教育出版社 | 南方E课堂', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
            imgUrl: this.detail.image // 图片, 默认取网页中第一个img标签
          });
        }).catch((e) => {
          console.log("e", e);
        });
      } else {
        $utils.failToast({
          message: '信息为空',
          onClose: () => {
            $router.go(-1);
          }
        });
      }
    },

    /* 获取书籍信息 */
    getBookDetail () {
      const { $http, id, bookDetail } = this;
      const { pageSize, pageNo } = this;
      $http.get('books/list', {
        params: {
          key: '',
          bookshelfId: id,
          pageNo,
          pageSize
        }
      }).then((res) => {
        const { isHasNext, nextPage, result, totalCount } = res.data || {};
        bookDetail.loading = false;
        bookDetail.finished = !isHasNext;
        bookDetail.pageNo = nextPage;
        bookDetail.totalCount = totalCount;
        bookDetail.list.push(...result);

        this.bookDetail = bookDetail;
      });
    },

    /* 点击收藏按钮 */
    itemClick () {
      let { $utils, $http, id } = this;
      if (this.detail.code == -1){

      }
      $http.post('bookshelf/collect', {
        id
      }, {
        showLoading: true
      }).then((res) => {
        this.detail.isCollected = !this.detail.isCollected;
        this.detail.isCollected ? $utils.successToast('收藏成功') : $utils.successToast('取消收藏');
      });
    }


  }

};
</script>

<style scoped lang="less">
  .Detail {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .container{
      flex: 1;
      padding-bottom: 100px;
      .box {
        .box_title{
          width: 100%;
          .img{
            width: 100%;
            height: 500px;
          }
        }
        .box_content{
          background: #FFFFFF;
          /*background: #555555;*/
          border-radius: 28px 28px 0px 0px;
          padding: 56px 28px;
          position: relative;
          top: -18px;
          border-bottom: 20px solid #F9FAFC;
          .title{
            font-size: 36px;
            line-height: 56px;
            color: #333444;
            margin-bottom: 56px;
            /*display: flex;*/
            justify-content: space-between;
            .left{
              font-weight: bolder;
            }
            .right{
              display: flex;
              font-size: 24px;
              color: #333333;
              align-items: center;
              .img{
                width: 32px;
                height: 32px;
                margin-right: 6px;
                vertical-align: middle;
              }
              .text{
                margin-right: 26px;
              }
              .box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                .list_item{
                  display: flex;
                  align-items: center;
                  .icon{
                    width: 32px;
                    height: 32px;
                    margin-right: 6px;
                    background-image: url('~@/assets/images/book/icon_19.png');
                    background-size: contain;
                    &.active{
                      background-image: url('~@/assets/images/book/icon_18.png');
                    }
                  }
                  .text{
                    margin-right: 0;
                  }
                }
                .box_right{
                  .btn{
                    width: 450px;
                    background: linear-gradient(270deg, #FFAF19 0%, #FF7C36 100%);
                    border-radius: 44px;
                    font-size: 26px;
                    height: 76px;
                    color: #FFFFFF;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }
          }
          .text{
            font-size: 26px;
            color: #67677A;
          }
        }
      }


      .box2{
        padding:32px 28px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: start;
        .box_item{
          margin-right: 46px;
          margin-top: 40px;
          width: 200px;
          display: flex;
          flex-direction: column;
          &:nth-child(-n+3){
            margin-top: 0;
          }
          &:nth-child(3n){
            margin-right: 0px;
          }
          .img{
            width: 100%;
            height: 280px;
            border-radius: 8px;
            overflow: hidden;
          }
        }
        &.box1{
          .box_item{
            position: relative;
            .releative{
              position: relative;
              .img{
                z-index: 2;
              }
              .info{
                position: absolute;
                z-index: 11;
                bottom: 0;
                display: flex;
                right: 0;
                flex-direction: column;
                justify-content: center;
                &::before {
                  display: block;
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background: rgba(255, 255, 255, .1);
                  backdrop-filter: blur(60px);
                }
                .text{
                  font-size: 20px;
                  color: #FFFFFF;
                  display: flex;
                  position: relative;
                  align-items: center;
                  padding:4px 12px;
                  .icon_book{
                    width: 19px;
                    height: 18px;
                    vertical-align: middle;
                    background-image: url("~@/assets/images/icon_book_03.png");
                    background-size: contain;
                    display: inline-block;
                    margin-right: 6px;
                    background-repeat: no-repeat;
                  }
                }
              }
            }
            .content{
              position: absolute;
              width: 98%;
              height: 86%;
              background: #000000;
              opacity: 0.2;
              border-radius: 0.10667rem;
              z-index: 1;
              left: 0;
              right: 0;
              margin: 0 auto;
              &::after{
                content:"";
                position: absolute;
                display: block;
                width: 90%;
                height: 101.5%;
                background: #000000;
                opacity: 0.65;
                border-radius: 0.10667rem;
                z-index: 1;
                left: 0;
                right: 0;
                margin: 0 auto;
              }
            }
            .title{
              margin-top: 20px;
              font-size: 22px;
              color: #333333;
              text-align: center;
            }

          }

        }
        &.box2{
          .box_item{
            .info{
              .title{
                margin-top: 16px;
                font-size: 24px;
                color: #333444;
              }
            }
          }
        }
      }

      .list_test{
        .list_item{
          display: flex;
          .text{
            font-size: 34px;
          }
          .input{
            width: 40%;
            height: 60px;
          }
        }
      }
      .addBtn{
        background-color: #eee;
        font-size: 36px;
      }


      /deep/#emptyComp{
        padding-top: 1rem;
        padding-bottom: 0rem;
        min-height: auto;
      }
    }
  }
</style>
